import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { GrupoService } from '../../../../services/grupo.service';
import { EmpresaService } from '../../../../services/empresa.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-actempresa',
  templateUrl: './actempresa.component.html',
  styleUrls: ['./actempresa.component.css'],
  providers: [GrupoService, EmpresaService]
})
export class ActempresaComponent implements OnInit {
  public identity;
  public token;
  public status;
  public message_success;
  public message_error;
  public empresas: any = null;
  public empresa: any = null;
  public showEmpresa: any = null

  public dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any> = new Subject();

  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;

  constructor(
    private _router: Router,
    private _grupoService: GrupoService,
    private _empresaService: EmpresaService,
  ) {
    this.token = this._grupoService.getToken();
  }

  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    }
    this.getEmpresas()
  }

  getEmpresas() {

    this._empresaService.getAllEmpresas(this.token).subscribe(
      response => {
        if (response.status == 'success') {
          this.empresas = response.empresas;
          this.dtTrigger.next()
        }
      },
      error => {
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        } else {
          alert('Existe problemas con el servidor, favor de intentar más tarde');
        }
      }
    );
  }

  showInfoEmpresa(empresa) {
    this.showEmpresa = true
    this.empresa = empresa
  }

  updateEmpresa(empresa_id) {
    let rfc = $("#rfcAct" + empresa_id).val();
    let denominacion = $("#denAct" + empresa_id).val();
    let nombre_establecimiento = $("#nesAct" + empresa_id).val();
    let habitaciones = $("#habAct" + empresa_id).val();
    let calle = $("#calleAct" + empresa_id).val();
    let no_interior = $("#noinAct" + empresa_id).val();
    let no_exterior = $("#noexAct" + empresa_id).val();
    let cp = $("#cpAct" + empresa_id).val();
    let colonia = $("#colAct" + empresa_id).val();
    let referencia_bancaria = $("#refb" + empresa_id).val();
    let domicilio_fiscal = $("#domAct" + empresa_id).val();

    let info = {
      rfc, denominacion, nombre_establecimiento, habitaciones, calle, no_interior,
      no_exterior, cp, colonia, referencia_bancaria, domicilio_fiscal
    }

    this._empresaService.updateEmpresaFromAdmin(this.token, empresa_id, info).subscribe(
      response => {
        if (response.status == 'success') {

          $(".empresa").show();

          this.status = 'success';
          this.message_success = response.message;

          setTimeout(function () {
            $(".empresa").fadeTo(500, 1).slideUp(500, function () {
              $(".empresa").hide();
            });
          }, 3000)

        }
      },
      error => {
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        } else {
          $(".empresa").show();
          this.status = 'error';
          this.message_error = error['error']['message'];

          setTimeout(function () {
            $(".empresa").fadeTo(500, 1).slideUp(500, function () {
              $(".empresa").hide();
            });
          }, 3000)
        }
      }
    );
  }

  updateCredenciales(representante_id) {
    let email = $("#emailAct" + representante_id).val();
    let password = $("#passwordAct" + representante_id).val();

    let info = { email, password }

    this._empresaService.updateCredentials(this.token, representante_id, info).subscribe(
      response => {
        if (response.status == 'success') {

          $(".empresa").show();

          this.status = 'success';
          this.message_success = response.message;

          setTimeout(function () {
            $(".empresa").fadeTo(500, 1).slideUp(500, function () {
              $(".empresa").hide();
            });
          }, 3000)

        }
      },
      error => {
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        } else {
          $(".empresa").show();
          this.status = 'error';
          this.message_error = error['error']['message'];

          setTimeout(function () {
            $(".empresa").fadeTo(500, 1).slideUp(500, function () {
              $(".empresa").hide();
            });
          }, 3000)
        }
      }
    );
  }

}
